import { TableCell, TextField, InputAdornment } from '@mui/material';

/** Shared sx styles for pricing input TextFields */
const PRICING_INPUT_SX = {
  '& .MuiOutlinedInput-root': {
    bgcolor: 'background.paper',
    '&:not(.Mui-disabled)': {
      bgcolor: 'background.paper',
    },
  },
  '& .MuiOutlinedInput-input': {
    py: 0.75,
  },
} as const;

/** Helper component for displaying pricing in table cells */
export const PricingCell = ({
  value,
  isReadOnly,
  inputValue,
  onChange,
  disabled,
  width,
  showError,
}: {
  value: number | null | undefined;
  isReadOnly: boolean;
  inputValue: string;
  onChange: (value: string) => void;
  disabled: boolean;
  width: string;
  showError?: boolean;
}) => {
  if (isReadOnly) {
    return (
      <TableCell width={width}>
        {value !== null && value !== undefined && !Number.isNaN(value)
          ? `$${value.toFixed(2)}`
          : ''}
      </TableCell>
    );
  }

  return (
    <TableCell width={width} sx={{ p: 1 }}>
      <TextField
        value={inputValue}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        size="small"
        fullWidth
        error={showError}
        InputProps={{
          startAdornment: <InputAdornment position="start">$</InputAdornment>,
        }}
        sx={PRICING_INPUT_SX}
      />
    </TableCell>
  );
};
